import { Injectable } from '@angular/core';
// import * as firebase from 'firebase/app';
import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreDocument, AngularFirestoreCollection } from '@angular/fire/firestore';

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/switchMap';
import { Router, ActivatedRoute } from '@angular/router';
import * as AWS from 'aws-sdk/global';
import * as S3 from 'aws-sdk/clients/s3';

interface User {
  uid: string;
  email: string;
  catchPhrase?: string;
}
interface Admin {
  name: string;
  username: string;
  email: string;
  password: string;
  role: string;
  status: boolean;
  createdAt?: string;
  id?:any

}

@Injectable()
export class AuthService {
  user: any;
  admindata: any;
  url: any = '';
  constructor(private afAuth: AngularFireAuth,
    private router: Router,
    private route: ActivatedRoute,
    private afs: AngularFirestore) { }

  checkuser(path) {
    const user = JSON.parse(localStorage.getItem('user'));
    this.user = user
    // this.afAuth.authState.subscribe(data => {
    const url = path || this.router.url;

    if (!user) {
        this.router.navigate(['/login']);
      } else {
        if (url == '/change-password' || url == '/login') {
          return true;
        }
       if (user.role !== 'SA') {
         const role = user.role;
         const access1 = url.search(role === 'CE' ? 'tickets' : 'comic');
         const access2 = url.search(role === 'CE' ? 'ticket-single' : 'novel');
         if(role=='CE'&&url == '/') this.router.navigate(['/tickets']);
          if (access1 == -1 && access2 == -1 ) {
            const urlnav = role === 'CE' ? '/tickets' : '/comic-series'
            this.router.navigate([urlnav]);
          } else {
            return true
            // this.router.navigate([url]);
            // this.router.navigate(['/login']);
          }
        } else {
         return true;
        }
      }
    // });
  }
  async getuser() {
    try {
      return new Promise((resolve) => {
        this.afAuth.user.subscribe(userid => {
          if (!userid) {return true; }
          const userdoc: AngularFirestoreDocument<User> = this.afs.doc(`/admin/${userid.uid}`);
          userdoc.valueChanges().subscribe(user => {
            const details = user;
            details.uid = userid.uid;
            resolve(details);
          });
        });
      });
    } catch (error) {
      console.log(error);
    }
  }
  logout() {
    this.afAuth.auth.signOut().then(data => {
      localStorage.clear();
      this.router.navigate(['/login']);
    });
  }
  // adding the admin details and login privelages like sub admin,staff, etc
  async signupuser(user) {
    const admin: Admin = {
      name: user.name,
      username: user.username,
      email: user.email,
      password: user.password,
      role: user.role,
      status: user.status === 'true' ? true : false
    };
    try {
      if (user.id) {
        const document = this.afs.doc('/admin/' + user.id);
        document.update(admin);
        return true;
      } else {
        admin.createdAt=new Date().toString()
        const createduser = await this.afAuth.auth.createUserWithEmailAndPassword(user.email, user.password);
        admin.id = createduser.uid;
        this.admindata = this.afs.collection('admin').doc(createduser.uid).set(admin);
      }
    } catch (error) {
      console.log(error);
      throw error;
    }
  }

  async loginadmin(email, password): Promise<any> {
    try {
      const login = await this.afAuth.auth.signInWithEmailAndPassword(email, password);
      const admin = await this.afs.doc(`admin/${login.uid}`);
      admin.valueChanges().subscribe(data => {
        localStorage.setItem('user', JSON.stringify(data));
        this.user = data;
         const roleurl = this.user.role=='CE'?'/tickets':'/'
        this.router.navigate([roleurl])
      });
      return admin.valueChanges();
    } catch (error) {
      console.log(error);
      throw error;
    }
  }
  async getsingleadmin(id) {
    const admin = await this.afs.doc(`admin/${id}`);
    const admindata = await admin.valueChanges();
    return admindata;
  }
  async uploadimage(folder, image, url) {
    // folder => path to upload the image,
    // image => file to upload,
    // url => the old file that want to replace when update
    return new Promise((resolve) => {
      try {
        var region = 'nyc3';  // New York region by default
        var spacesEndpoint = new AWS.Endpoint(region + '.digitaloceanspaces.com');

        const bucket = new S3({
          accessKeyId: 'OHIPOFDAOKGQVWBGO3OQ',
          secretAccessKey: 'gMtjFhUzsXgRyp8vEs3O1H9IOyEuYvNFCVSpTmsRoI0',
          endpoint: <any>spacesEndpoint
        });

        const params = {
          Bucket: 'webnnel',
          ACL: 'public-read',
          Key: folder + ((Date.now() + Math.floor(Math.random() + 9992)).toString() + image.name),
          Body: new Blob([image], { type: image.type })
        };

        const options = {
          partSize: 10 * 1024 * 1024, //10MB,
          queueSize: 10
        };
        if (url) {
          const delete_params = {
            Key: url.slice(44),
            Bucket: 'webnnel',
            // Body: new Blob([image], { type: image.type })
          };
          bucket.deleteObject(delete_params, function (err, data) {
            if (err) { console.error(err); }
            console.log('deleted successfully', data);
          });
        }
        bucket.upload(params, options, function (err, data) {
          if (err) {
            console.log('There was an error uploading your file: ', err);
            return false;
          }
          console.log('Successfully uploaded file.', data);
          return resolve(data);
        });
      } catch (error) {
        console.log(error);
        throw error;
      }
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/service/auth.service.ts